
export const consoleLog = (msg) => {
  const cont = document.getElementById('ctime');
    if (cont) {
      const msg1 = cont.innerHTML;
      msg = msg1 + "<br/>\n" + msg;
      cont.innerHTML = msg;
    }
}

export const getDataOfConfigSteamsTypes = (options) => {
  const server_url = options.drmInfo.server_url ? options.drmInfo.server_url : null;
  const challenge = (options.drmInfo && options.drmInfo.challenge) || '';
  const content_id = (options.drmInfo && options.drmInfo.content_id) || '';
  const device_id = options.drmInfo.device_id || '';
  const cert = options.drmInfo.resultCert;
  const certificate_url = options.drmInfo.certificate_url;
  const src = options.src;

  let customData = null;
  if (challenge && challenge.indexOf('tokenID') !== -1) {
      customData = challenge;
  } else {
      customData = btoa(`{"customdata":${challenge},"device_id": "${device_id}"}`);
  }
  const jsonSimple = '{ "customdata":' + challenge + ',"device_id": ' + device_id + '}';

  return {
      server_url,
      challenge,
      content_id,
      device_id,
      customData,
      jsonSimple,
      cert,
      certificate_url,
      src,
  };
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/streams-types-config/utilsStreamTypesConfig.js